import {Component, ElementRef} from '@angular/core';
import {NavigationService} from '../navigation/navigation.service';

@Component({
  selector: 'app-scroll-to-top-btn',
  templateUrl: './scroll-to-top-btn.component.html',
})
export class ScrollToTopBtnComponent {

  constructor(
    public navigationService: NavigationService,
    private elRef: ElementRef
  ) {
  }

  scrollIntoView(): any {
    this.elRef.nativeElement.scrollIntoView();
  }
}
